import type {
  ExportNewRoutingReportFailed,
  ExportNewRoutingReportRequest,
  ExportNewRoutingReportSucceeded,
  ExportRoutesFailed,
  ExportRoutesRequest,
  ExportRoutesSucceeded,
  RouteExecutionInfoFailed,
  RouteExecutionInfoRequest,
  RouteExecutionInfoSucceeded,
  RoutesDeleteFailed,
  RoutesDeleteRequest,
  RoutesDeleteSucceeded,
  RouteUpdateFailed,
  RouteUpdateRequest,
  RouteUpdateSucceeded,
} from './actions';
import { ActionTypes } from './actionTypes';

import type {
  DateRange,
  ESN,
  TimestampInMillis,
  UUID,
} from '@cobliteam/common-types';

import type {
  DeleteRoutes,
  DeviceTrip,
  EditRoute,
  NewRoute,
  NewRoutingReportType,
} from '@cobliteam/api-lib';

export const routeUpdateRequest = (route: EditRoute): RouteUpdateRequest => ({
  type: ActionTypes.ROUTE_UPDATE_REQUEST,
  payload: route,
});

export const routeUpdateFailed = (errorMessage: string): RouteUpdateFailed => ({
  type: ActionTypes.ROUTE_UPDATE_FAILED,
  payload: errorMessage,
});

export const routeUpdateSucceeded = (
  route: NewRoute
): RouteUpdateSucceeded => ({
  type: ActionTypes.ROUTE_UPDATE_SUCCESS,
  payload: route,
});

export const routeExecutionInfoRequest = (
  deviceId: ESN,
  startTime: TimestampInMillis,
  endTime: TimestampInMillis,
  mapMatch: boolean
): RouteExecutionInfoRequest => ({
  type: ActionTypes.ROUTE_EXECUTION_INFO_REQUEST,
  payload: { deviceId, startTime, endTime, mapMatch },
});

export const routeExecutionInfoFailed = (): RouteExecutionInfoFailed => ({
  type: ActionTypes.ROUTE_EXECUTION_INFO_FAILED,
});

export const routeExecutionInfoSucceeded = (
  routeInfo: DeviceTrip
): RouteExecutionInfoSucceeded => ({
  type: ActionTypes.ROUTE_EXECUTION_INFO_SUCCEEDED,
  payload: routeInfo,
});

export const routesDeleteRequest = (payload: {
  routesToDelete: DeleteRoutes;
  notifyDeleteRouteRequestResult?: boolean;
}): RoutesDeleteRequest => ({
  type: ActionTypes.ROUTES_DELETE_REQUEST,
  payload,
});

export const routesDeleteFailed = (): RoutesDeleteFailed => ({
  type: ActionTypes.ROUTES_DELETE_FAILED,
});

export const routesDeleteSucceeded = (ids: UUID[]): RoutesDeleteSucceeded => ({
  type: ActionTypes.ROUTES_DELETE_SUCCESS,
  payload: ids,
});

export const exportRoutesRequest = (route: NewRoute): ExportRoutesRequest => ({
  type: ActionTypes.EXPORT_ROUTES_REQUEST,
  payload: { route },
});

export const exportRoutesFailed = (): ExportRoutesFailed => ({
  type: ActionTypes.EXPORT_ROUTES_FAILED,
});

export const exportRoutesSucceeded = (): ExportRoutesSucceeded => ({
  type: ActionTypes.EXPORT_ROUTES_SUCCESS,
});

export const exportNewRoutingReportRequest = (
  reportType: NewRoutingReportType,
  dateRange: DateRange
): ExportNewRoutingReportRequest => ({
  type: ActionTypes.EXPORT_NEW_ROUTING_REPORT_REQUEST,
  payload: { reportType, dateRange },
});

export const exportRoutesReportFailed = (): ExportNewRoutingReportFailed => ({
  type: ActionTypes.EXPORT_NEW_ROUTING_REPORT_FAILED,
});

export const exportRoutesReportSucceeded =
  (): ExportNewRoutingReportSucceeded => ({
    type: ActionTypes.EXPORT_NEW_ROUTING_REPORT_SUCCESS,
  });
